
/**
 * Generates an SEO-friendly URL slug from a given title.
 *
 * Rules:
 * - Converts text to lowercase
 * - Removes punctuation and special characters
 * - Replaces spaces with hyphens
 * - Collapses multiple hyphens into one
 * - Trims to a maximum length without cutting words
 *
 * Slugs are intended for readability and SEO only.
 * They are not guaranteed to be unique and should not be used as identifiers.
 *
 * @param title The source title (e.g. project or post title)
 * @param maxLength Maximum length of the generated slug (default: 80)
 * @returns SEO-friendly slug string
 */
export function generateSeoSlug(title: string, maxLength: number = 80): string {
  if (!title || !title.trim()) {
    return '';
  }

  // 1. Normalize casing and trim
  let slug = title
    .toLowerCase()
    .trim();

  // 2. Remove invalid characters (keep letters, numbers, spaces, hyphens)
  slug = slug.replace(/[^a-z0-9\s-]/g, '');

  // 3. Replace one or more spaces with a single hyphen
  slug = slug.replace(/\s+/g, '-');

  // 4. Collapse multiple hyphens into one
  slug = slug.replace(/-+/g, '-');

  // 5. Enforce max length without cutting words
  if (slug.length > maxLength) {
    slug = slug.substring(0, maxLength);

    const lastHyphenIndex = slug.lastIndexOf('-');
    if (lastHyphenIndex > 0) {
      slug = slug.substring(0, lastHyphenIndex);
    }
  }

  // if(isLocal())
  //   console.log(slug);

  return slug;
}